import { RewardIntentionStatus } from 'enums/reward'

export const getRewardStatusLabel = {
  [RewardIntentionStatus.Accepted]: 'Accepted',
  [RewardIntentionStatus.Banked]: 'Banked',
  [RewardIntentionStatus.Redeemed]: 'Redeemed',
  [RewardIntentionStatus.Waiting]: 'Waiting',
}
